import { extractNumber } from './extractNumber';
import { extractUnit } from './extractUnit';

export const parseNumberString = ({
  value,
  supportedUnits,
}: {
  value?: string | number;
  supportedUnits?: string[];
}) => {
  if (value === undefined) return {};

  const number = extractNumber(value);
  const unit = supportedUnits ? extractUnit(value, supportedUnits) : undefined;

  return {
    number,
    unit,
  };
};
